import type { DashboardWidgetConfiguration } from './widget-definition';

export const financeCashPositionWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.cash-position",
  name: "Cash and credit position",
  description: "Posted Finance journal balances at a selected date, scoped by RQL permissions.",
  apps: [
    "finance",
  ],
  template: "finance-money",
  query: {
    kind: "component",
    owner: "finance-money",
  },
  inputs: {
    title: "Cash and credit position",
    mode: "cash",
  },
  dummyData: {
    value: "Posted balances",
    rows: [],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 4,
    maxHeight: 12,
    defaultWidth: 12,
    defaultHeight: 6,
  },
};
